import React from 'react';
import { Card, Typography } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import JoinProjectAsSubscriberAdminButton from '../project-users/JoinProjectAsSubscriberAdminButton';

export default function SubscriberAdminJoinProjectCard() {
  return (
    <Card style={{ height: '100%' }}>
      <CardContent
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          // Centered as a group rather than pinned to the top and bottom: the card stretches to
          // the height of its dashboard row, which a long project name can make tall.
          justifyContent: 'center',
          gap: 16,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" style={{ fontSize: 17 }}>
          You are a subscriber admin
        </Typography>
        <JoinProjectAsSubscriberAdminButton />
      </CardContent>
    </Card>
  );
}
